export type ContaFinanceiraModo = 'pagar' | 'receber';

export interface ContaFinanceiraUiConfig {
  modo: ContaFinanceiraModo;
  tituloBaixas: string;
  labelPagador: string;
  labelTotal: string;
  labelDataBaixa: string;
  labelFormaBaixa: string;
  labelStatus: string;
  situacaoAberta: string;
  situacaoQuitada: string;
  exibirFormaCobranca?: boolean;
  exibirDadosBanco?: boolean;
  exibirContaCorrente?: boolean;
  exibirSegmento?: boolean;
}

export interface BaixaLinha {
  formaPagamento: string;
  valor: number;
  dataPagamento: string;
  possuiComprovante: boolean;
}

export const CONFIG_CONTA_PAGAR: ContaFinanceiraUiConfig = {
  modo: 'pagar',
  tituloBaixas: 'BAIXAS DE PAGAMENTO',
  labelPagador: 'Favorecido',
  labelTotal: 'Total A Pagar',
  labelDataBaixa: 'Data de Pagamento',
  labelFormaBaixa: 'Formas de Pagamento',
  labelStatus: 'Status do Pagamento',
  situacaoAberta: 'A_PAGAR',
  situacaoQuitada: 'PAGO',
  exibirSegmento: true,
};

export const CONFIG_CONTA_RECEBER: ContaFinanceiraUiConfig = {
  modo: 'receber',
  tituloBaixas: 'BAIXAS DE RECEBIMENTO',
  labelPagador: 'Pagador',
  labelTotal: 'Total A Receber',
  labelDataBaixa: 'Data de Recebimento',
  labelFormaBaixa: 'Formas de Recebimento',
  labelStatus: 'Status do Recebimento',
  situacaoAberta: 'A_RECEBER',
  situacaoQuitada: 'RECEBIDO',
  exibirFormaCobranca: true,
  exibirDadosBanco: true,
  exibirContaCorrente: true,
  exibirSegmento: true,
};
